import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  items: []
}

const getActions = generateActions('about/faq/GET_ITEMS')

export const getItems = createAction(
  API_CONST,
  () => ({
    actions: getActions,
    url: `faq`
  })
)

export default handleActions({
  [getActions[0]]: state => ({ ...initial }),
  [getActions[1]]: (state, { payload }) => {
    return ({ ...state, items: payload })
  }
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/about/index.js